<header class="app-header">
  <div class="mobile-header-bar">
    <button type="button" class="mobile-icon-btn" aria-label="Mở menu" (click)="toggleMobileMenu()">☰</button>

    <div class="mobile-logo" role="button" tabindex="0" aria-label="Logo" (click)="onAlibabaClick()" (keydown.enter)="onAlibabaClick()">NEXTRA GLOBAL</div>

    <div class="mobile-actions">
      <button *ngIf="!isLoggedIn" type="button" class="mobile-icon-btn mobile-login-btn" aria-label="Đăng nhập"
        (click)="openAuthDialog('login')">
        Đăng nhập
      </button>

      <div *ngIf="isLoggedIn" class="user-menu mobile-user-menu">
        <span class="mobile-notification-balance" role="button" tabindex="0" (click)="openBalanceDialog($event)"
          (keydown.enter)="openBalanceDialog($event)">
          {{ formattedBalance }}
        </span>
        <div class="notification-menu">
          <button type="button" class="mobile-notification-btn" aria-label="Thông báo" (click)="toggleNotifications($event)">
            🔔
           <span class="notification-badge" *ngIf="unreadCount > 0">   {{ unreadCount }} </span>
          </button>
          <div *ngIf="notificationsVisible" class="notification-dropdown" role="menu" aria-label="Thông báo">
            <div class="notification-state" *ngIf="notificationsLoading">Đang tải...</div>
            <div class="notification-state notification-state--error" *ngIf="!notificationsLoading && notificationsError">
              {{ notificationsError }}
            </div>
            <div class="notification-state" *ngIf="!notificationsLoading && !notificationsError && notifications.length === 0">
              Không có thông báo
            </div>
            <div class="notification-list" *ngIf="!notificationsLoading && !notificationsError && notifications.length">
              <button type="button" class="notification-item" *ngFor="let item of notifications" (click)="onOpenNotification(item)">
                <span class="notification-avatar" aria-hidden="true">
                  <ng-container *ngIf="getNotificationAvatarUrl(item) as avatarUrl; else mobileAvatarText">
                    <img [src]="avatarUrl" alt="" />
                  </ng-container>
                  <ng-template #mobileAvatarText>{{ getNotificationAvatarText(item) }}</ng-template>
                </span>
                <span class="notification-body">
                  <span class="notification-title" [class.unread]="!item.isRead"> {{ getNotificationTitle(item) }}</span>
                  <span class="notification-subtitle" *ngIf="getNotificationSubtitle(item)">{{ getNotificationSubtitle(item) }}</span>
                </span>
                <span class="notification-time">{{ getNotificationTime(item) }}</span>
              </button>
            </div>
          </div>
        </div>
        <button type="button" class="mobile-avatar-btn" aria-label="Tài khoản" (click)="toggleDropdown()">
          <img [src]="user.avatar" alt="Avatar" />
        </button>
      </div>

    </div>
  </div>

  <div class="mobile-search-bar">
    <input class="search-input" type="text" placeholder="Tìm kiếm" (input)="onSearchInput($event)"
      (keyup.enter)="onSearchSubmit()" [(ngModel)]="searchKeyword" />
    <button class="search-clear" type="button" aria-label="Xóa từ khóa" *ngIf="searchKeyword"
      (click)="clearSearch()">✕</button>
    <button class="search-btn" type="button" aria-label="Tìm kiếm" (click)="onSearchSubmit()">
      <svg viewBox="0 0 24 24" class="search-icon" aria-hidden="true">
        <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2" />
        <path d="M20 20l-4.2-4.2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
  </div>

  <div class="header-inner">
    <div class="brand">
      <button type="button" class="header-mobile-menu-btn" aria-label="Mở menu" (click)="toggleMobileMenu()">☰</button>
      <span class="brand-name" role="button" tabindex="0" (click)="onAlibabaClick()" (keydown.enter)="onAlibabaClick()">
        NEXTRA GLOBAL
        <!-- <span class="brand-subname">ALIEXPRESS</span> -->
      </span>
    </div>

    <div class="search-bar">
      <input class="search-input" type="text" placeholder="Tìm kiếm" (input)="onSearchInput($event)"
        (keyup.enter)="onSearchSubmit()" [(ngModel)]="searchKeyword" />
      <button class="search-clear" type="button" aria-label="Xóa từ khóa" *ngIf="searchKeyword"
        (click)="clearSearch()">✕</button>
      <button class="search-btn" type="button" aria-label="Tìm kiếm" (click)="onSearchSubmit()">
        <svg viewBox="0 0 24 24" class="search-icon" aria-hidden="true">
          <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2" />
          <path d="M20 20l-4.2-4.2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <div class="header-actions">
      <button *ngIf="!isLoggedIn" class="action-btn price-btn" type="button" (click)="openAuthDialog('login')">
        <span class="price-label">Đăng nhập</span>
      </button>

      <div *ngIf="isLoggedIn" class="user-menu">
        <span class="notification-balance" role="button" tabindex="0" (click)="openBalanceDialog($event)"
          (keydown.enter)="openBalanceDialog($event)">
          <span class="balance-label">Số dư:</span>
          <span class="balance-value">{{ formattedBalance }}đ</span>
        </span>
        <div class="notification-menu">
          <button type="button" class="notification-btn" aria-label="Thông báo" (click)="toggleNotifications($event)">
            🔔
            <span class="notification-badge" *ngIf="unreadCount > 0">   {{ unreadCount }} </span>
          </button>
          <div *ngIf="notificationsVisible" class="notification-dropdown" role="menu" aria-label="Thông báo">
            <div class="notification-state" *ngIf="notificationsLoading">Đang tải...</div>
            <div class="notification-state notification-state--error" *ngIf="!notificationsLoading && notificationsError">
              {{ notificationsError }}
            </div>
            <div class="notification-state" *ngIf="!notificationsLoading && !notificationsError && notifications.length === 0">
              Không có thông báo
            </div>
            <div class="notification-list" *ngIf="!notificationsLoading && !notificationsError && notifications.length">
              <button type="button" class="notification-item" *ngFor="let item of notifications"(click)="onOpenNotification(item)">
                <span class="notification-avatar" aria-hidden="true">
                  <ng-container *ngIf="getNotificationAvatarUrl(item) as avatarUrl; else desktopAvatarText">
                    <img [src]="avatarUrl" alt="" />
                  </ng-container>
                  <ng-template #desktopAvatarText>{{ getNotificationAvatarText(item) }}</ng-template>
                </span>
                <span class="notification-body">
                  <span class="notification-title" [class.unread]="!item.isRead"> {{ getNotificationTitle(item) }}</span>
                  <span class="notification-subtitle" *ngIf="getNotificationSubtitle(item)">{{ getNotificationSubtitle(item) }}</span>
                </span>
                <span class="notification-time">{{ getNotificationTime(item) }}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="user-avatar" id="avatar-btn" (click)="toggleDropdown()">
          <img [src]="user.avatar" alt="Avatar" />
        </div>

        <div *ngIf="dropdownVisible && !isMobileView" class="user-dropdown user-dropdown--desktop">
          <div class="desktop-sheet">
            <ng-container *ngTemplateOutlet="userSheetContent"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<div class="user-sheet-backdrop" *ngIf="dropdownVisible && isMobileView" (click)="toggleDropdown()">
  <section class="user-bottom-sheet" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
    <div class="sheet-handle"></div>
    <ng-container *ngTemplateOutlet="userSheetContent"></ng-container>
  </section>
</div>

<ng-template #userSheetContent>
  <div class="sheet-user-block sheet-user-block--left">
    <div class="sheet-avatar-wrap">
      <button type="button" class="sheet-user-avatar" (click)="openAvatarPreview()">
        <img [src]="user.avatar" alt="Avatar" />
      </button>
      <label class="sheet-avatar-upload" [class.is-loading]="avatarUploading">
        <input type="file" class="sheet-avatar-input" accept="image/*" (change)="onAvatarSelected($event)"
          [disabled]="avatarUploading" />
        <span class="sheet-avatar-icon" aria-hidden="true">+</span>
      </label>
    </div>
    <div class="sheet-user-name">{{ user.displayName }}</div>
    <div class="sheet-avatar-message" *ngIf="avatarMessage" [class.is-error]="avatarError">
      {{ avatarMessage }}
    </div>
  </div>

  <div class="sheet-section-actions">
    <button type="button" class="sheet-balance-toggle" (click)="openBankDialog()">
        <span class="sheet-option-left">
        <span class="sheet-option-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" class="sheet-option-svg" aria-hidden="true">
            <path d="M3 9.5L12 5l9 4.5M5 10v8h14v-8M7.5 18v-6M12 18v-6M16.5 18v-6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
          <span>Thông tin tài khoản ngân hàng</span>
        </span>
    </button>
      <button type="button" class="sheet-balance-toggle" (click)="openEditProfile()">
        <span class="sheet-option-left">
          <span class="sheet-option-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" class="sheet-option-svg" aria-hidden="true">
              <path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4Zm-7 7a7 7 0 0 1 14 0" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
          <span>Chỉnh sửa hồ sơ</span>
        </span>
      </button>
      <button type="button" class="sheet-balance-toggle" (click)="openChangePassword()">
        <span class="sheet-option-left">
          <span class="sheet-option-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" class="sheet-option-svg" aria-hidden="true">
              <path d="M7 11V8a5 5 0 0 1 10 0v3M6 11h12v8H6z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
          <span>Thay đổi mật khẩu</span>
        </span>
      </button>
  </div>
  <button type="button" class="sheet-logout-btn" (click)="logout()">
    <span class="logout-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" class="sheet-option-svg" aria-hidden="true">
        <path d="M3 12h10M9 8l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14 4h4a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </span>
    <span>Đăng xuất</span>
  </button>
</ng-template>

<app-profile-dialog [visible]="editProfileVisible" [userInfo]="currentUserInfo" [submitting]="profileSubmitting"
  [errorMessage]="profileMessage" [hasError]="profileError" (closed)="closeEditProfile()"
  (submitted)="handleProfileDialogSubmit($event)">
</app-profile-dialog>

<app-change-password-dialog [visible]="changePasswordVisible" [submitting]="passwordSubmitting"
  [errorMessage]="passwordMessage" [hasError]="passwordError" (closed)="closeChangePassword()"
  (submitted)="handleChangePasswordSubmit($event)">
</app-change-password-dialog>

<app-balance-dialog [visible]="balanceDialogVisible" [formattedBalance]="formattedBalance"
  [withdrawSubmitting]="withdrawSubmitting" [withdrawSubmitMessage]="withdrawSubmitMessage"
  [withdrawSubmitError]="withdrawSubmitError" [historyPreview]="withdrawHistory"
  (withdrawSubmitted)="submitWithdrawRequest($event)" (closed)="closeBalanceDialog()">
</app-balance-dialog>

<app-bank-dialog [visible]="bankDialogVisible" [userInfo]="currentUserInfo" (closed)="closeBankDialog()"
  (submitted)="submitBankDialog($event)">
</app-bank-dialog>

<app-auth-dialog
  (loggedIn)="onLoggedIn()"
  (registerSuccess)="openRegisterSuccessModal($event)">
</app-auth-dialog>
<!--
<app-auth-dialog (loggedIn)="onLoggedIn()"></app-auth-dialog> -->

<!-- Modal auto hiển thị khi load Header -->
<!-- ...existing code... -->

<!-- Modal chương trình hậu đãi (auto mở khi Header load và API có data) -->
<div class="header-modal-backdrop" *ngIf="showAfterSalesModal" (click)="closeAfterSalesModal()">
  <!-- Fireworks 4 góc -->
  <div class="fireworks" *ngIf="showWelcomeConfetti" aria-hidden="true">
    <i class="confetti c1" aria-hidden="true"></i>
    <i class="confetti c2" aria-hidden="true"></i>
    <i class="ribbon r1"></i>
    <i class="ribbon r2"></i>
    <i class="ribbon r3"></i>
    <i class="ribbon r4"></i>
    <i class="ribbon r5"></i>
    <i class="ribbon r6"></i>
    <i class="ribbon r7"></i>
    <i class="ribbon r8"></i>

    <i class="fw tl"></i>
    <i class="fw tr"></i>
    <i class="fw bl"></i>
    <i class="fw br"></i>
  </div>

  <div class="header-modal-card header-modal-card--welcome" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
    <div class="header-welcome-icon" aria-hidden="true">🎉</div>
    <h3 class="header-modal-title header-modal-title--welcome">Bạn có chương trình hậu đãi mới</h3>

    <div class="header-modal-body" *ngIf="afterSalesProgramData as p">
      <div class="header-modal-body-text">
        {{ p.description }}
      </div>
      <div class="header-modal-body-expired" *ngIf="p.expiredAt">
        Hạn áp dụng: <b>{{ p.expiredAt | date: 'dd/MM/yyyy' }}</b>
      </div>
    </div>

    <div class="header-modal-actions header-modal-actions--welcome">
      <button type="button" class="header-modal-ok header-modal-ok--welcome" (click)="closeAfterSalesModal()">OK</button>
    </div>
  </div>
</div>

<!-- ...existing code... -->

<div class="header-modal-backdrop" *ngIf="showRegisterSuccessModal" (click)="showRegisterSuccessModal = false">
  <div class="header-modal-card header-modal-card--welcome" (click)="$event.stopPropagation()">

    <div class="header-welcome-icon">🎉</div>

    <h3 class="header-modal-title">Chúc mừng bạn!</h3>

    <div class="header-modal-body">
      <p>
        Chúc mừng bạn may mắn nhận được <b>50.000 VND</b> sau khi đăng ký thành công,
        số tiền có thể rút về tài khoản ngân hàng sau khi liên kết đầy đủ thông tin.
      </p>

      <p style="margin-top: 12px;">
        Và may mắn nhận được <b>200.000 VND</b> có thể sử dụng cho đơn thanh toán kho hàng lần đầu.
        Vui lòng liên hệ bộ phận hỗ trợ để đăng ký nhận thưởng.
      </p>
    </div>

    <div class="header-modal-actions">
      <button class="header-modal-ok" (click)="closeRegisterSuccessModal()">
        OK
      </button>
    </div>
  </div>
</div>
